import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.agents')
  .factory('AgentPaymentCollectionAPI', AgentPaymentCollectionAPI);

function AgentPaymentCollectionAPI(): BringozApi {
  return {
    base: `/agents/{id}/wallet`,
    infiniteScroll: {
      address: `/agents/{id}/wallet`,
      cmd: 'GET'
    }
  }
}
